import { userProfileApi } from "../api";

const ProfileService = {

    getUserByEmail: async (email: string) => {
        try {
            const route = `/by-email?email=${email}`;
            const response = await userProfileApi.fetchCustom(route);
            return response;
        } catch (error: any) {
            console.error("Error obteniendo usuario por email:", error.response?.data || error.message);
            throw new Error("No se pudo obtener la información del usuario.");
        }
    },


    updatePersonalInfo: async (id: number, data: any) => {
        try {
            const route = `/update-personal/${id}`;
            return await userProfileApi.modifyCustom(route, data);
        } catch (error) {
            throw error;
        }
    },

    updatePassword: async (id: number, data: any) => {
        try {
            const route = `/update-password/${id}`;
            return await userProfileApi.modifyCustom(route, data);
        } catch (error) {
            throw error;
        }
    },

    uploadProfilePicture: async (id: number, file: File) => {
        try {
            const route = `/upload-profile-picture/${id}`;
            const formData = new FormData();
            formData.append("file", file);

            return await userProfileApi.uploadCustom(route, formData);
        } catch (error) {
            throw error;
        }
    },

    getProfilePictureUrl: async (id: number): Promise<Blob | null> => {
        try {
            const route = `/profile-picture/${id}`;
            const response = await userProfileApi.fetchBlob(route, { silentNotFound: true });
            if (!response.data) return null;
            return response.data;
        } catch (error) {
            return null;
        }
    },

    deleteProfilePicture: async (id: number) => {
        try {
            const route = `/profile-picture/${id}`;
            return await userProfileApi.removeCustom(route);
        } catch (error) {
            throw error;
        }
    },


    enableGoogleAuth: async (id: number) => {
        try {
            const route = `/enable-google-auth/${id}`;
            return await userProfileApi.addCustom(route, {});
        } catch (error) {
            throw error;
        }
    },
};

export default ProfileService;
